import * as types from './mutation-types'

export default {

  [types.LOAD_QVCT_SURVEY_REPORT](state, data) {
      state.qvctSurveysReport = data
  },

}
